<div (click)="closeRequested()" class="close"></div>
<div class="boxHeader">
    <img [src]="icon" />
    <h1>{{ name }}</h1>
</div>
